import React from 'react';
import { useSelector } from 'react-redux';

import CancerImage from '../../assets/images/death_reasons/cancerImage';
import CancerEng from '../../assets/images/death_reasons/cancerEng';
import CancerRus from '../../assets/images/death_reasons/cancerRus';
import Border from '../../assets/images/border';

import './cancer.scss';

const Cancer = () => {
    const { language } = useSelector(state => state.user);

    return (
        <div className='cancer'>
            <Border />
            {language === 'ENG' ? <CancerEng /> : <CancerRus />}
            <CancerImage />
            <span className='cancer-text'>
                {language === 'RUS' ? 'Высокая вероятность онкологических заболеваний указывает на существенный риск злокачественных образований, которые способны сильно повлиять на качество и продолжительность жизни.' : 'High probability of oncological diseases indicates a significant risk of malignant formations, which can significantly affect the quality and duration of life.'}
            </span>
        </div>
    );
};

export default Cancer;